import React, { Component } from 'react';
import ClickedOffManager from '../ui_core/ClickedOffManager';
import NearbySite from './NearbySite';
import './NearbySites.css';
export default class NearbySites{
	constructor(props){
		const {}=props;
		this._element = document.createElement('div');
		this._element.classList.add('nearby-sites');
		this.initialize = this.initialize.bind(this);
		this.show = this.show.bind(this);
		this.hide= this.hide.bind(this);
		this._setVisible= this._setVisible.bind(this);
		this._clickedOffManager = new ClickedOffManager({element:this._element, hide:this.hide});
	}
	initialize({siteJsons, thisSiteJson}){
		siteJsons.entries.forEach(siteJson=>{
			if(siteJson===thisSiteJson)return;
			const nearbySite = new NearbySite({siteJson, thisSiteJson});
			this._element.appendChild(nearbySite.element);
		});
	}
	get element(){
		return this._element;
	}
	show(){
		this._clickedOffManager.register();
		this._setVisible(true);
	}
	_setVisible(value){
		if(value)
			this._element.classList.add('visible');
		else 
			this._element.classList.remove('visible');
	}
	hide(){
		this._clickedOffManager.dispose();
		this._setVisible(false);
	}
}
